import React from 'react';
import PropTypes from 'prop-types';
// Components
import RichText from '../rich-text';
import { CTAAssembly } from '../cta';
import LinkHandler from '../link-handler';
// Styles
import {
  Hero,
  CardContent,
  Title,
  HeroContainer,
  ContentWrapper,
  HideForMobile,
  HideAboveMobile,
} from './styles';
// Utils
import { consistentString } from '../../utils/content-formatting';
import { useLayout } from '../layout/context';

const HeroContent = ({
  title,
  cardPosition,
  subtitleContent,
  link,
  linkText,
  heroCTA,
}) => (
  <ContentWrapper $position={consistentString(cardPosition)}>
    <CardContent>
      {title && <Title>{title}</Title>}
      {subtitleContent && <RichText richText={subtitleContent} />}
      {link && linkText && <LinkHandler link={link}>{linkText}</LinkHandler>}
      {heroCTA && (
        <CTAAssembly contentfulData={{ ...heroCTA }} marginBottom={false} />
      )}
    </CardContent>
  </ContentWrapper>
);

HeroContent.propTypes = {
  title: PropTypes.string,
  cardPosition: PropTypes.oneOf(['Left', 'Center', 'Right', 'Bottom']),
  subtitleContent: PropTypes.object,
  link: PropTypes.array,
  linkText: PropTypes.string,
  heroCTA: PropTypes.object,
};

const HeroWithCard = ({ content }) => {
  const { image, alignImage, ...rest } = content;

  const { insideContainer } = useLayout();

  return (
    <HeroContainer $removeMarginBottom={insideContainer}>
      <Hero $image={image} $alignImage={consistentString(alignImage)}>
        <HideForMobile>
          <HeroContent {...rest} />
        </HideForMobile>
      </Hero>
      <HideAboveMobile>
        <HeroContent />
      </HideAboveMobile>
    </HeroContainer>
  );
};

HeroWithCard.propTypes = {
  content: PropTypes.shape({
    quote: PropTypes.bool,
    image: PropTypes.object,
    alignImage: PropTypes.oneOf(['Top', 'Middle', 'Bottom']),
  }),
};

export default HeroWithCard;
